import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import 'app/App.scss';
import 'fonts/fonts';

import Home from 'app/screens/Home';
import Login from 'app/screens/Login';
import KioskNotFound from 'app/screens/KioskNotFound';
import LoadKiosk from 'app/components/LoadKiosk';

class App extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { locale, messages } = this.props;

    return (
      <div className="App">
        <IntlProvider defaultLocale="en" locale={locale} messages={messages}>
          <Router>
            <Route exact path="/">
              <KioskNotFound />
            </Route>
            <Route exact path="/:token">
              <LoadKiosk>
                <Home />
              </LoadKiosk>
            </Route>
            <Route exact path="/:token/login">
              <LoadKiosk>
                <Login />
              </LoadKiosk>
            </Route>
          </Router>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.messagesReducer.locale,
  messages: state.messagesReducer.messages
});

export default connect(mapStateToProps)(App);
